/*
 * View containing the response editor.
 * We need to include ckeditorJquery so that we can load the CKEditor, even though we don't
 * use the reference directly
 */

define(["marionette", "./template/responseEditorModalTemplate.html"], function (
  Marionette,
  ResponseEditorModalTemplate,
) {
  const ResponseEditorModalView = {};

  ResponseEditorModalView.responseEditorModalView = Marionette.Layout.extend({
    template: ResponseEditorModalTemplate,
    regions: {
      htmlEditor: ".html-editor",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
  });

  return ResponseEditorModalView;
});
